import React from "react";
import "./Home.scss";

import Hero from "../../components/hero/Hero";
import WhatWeBuild from "../../components/whatwebuild/WhatWeBuild";
import TechnologyStack from "../../components/technologystack/TechnologyStack";
import Indicators from "../../components/indicators/Indicators";
import Testimonials from "../../components/testimonials/Testimonials";
import Clients from "../../components/clients/Clients";
import ContactCTA from "../../components/contactcta/ContactCTA";
import InvestAfrica from "../../components/invest-africa/InvestAfrica";
import Ventures from "../../components/ventures/Ventures";

const Home = () => {
    return (
        <div className="home-page">
            <Hero />
            <WhatWeBuild />
            <InvestAfrica />
            <Ventures/>
            <TechnologyStack />
            <Indicators />
            <Testimonials />
            <Clients />
            <ContactCTA />
        </div>
    );
};

export default Home;